"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/esnext.json.parse.js");
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _leadsNotifications = require("@/api/notifications/leads-notifications");
var _index = _interopRequireDefault(require("@/components/Pagination/index.vue"));
var _index2 = require("@/utils/index");
var _excel = require("@/utils/excel");
var _admin = require("@/store/modules/admin");
var _eventBus = require("@/event-bus");
var _index3 = _interopRequireDefault(require("@/components/Enabled/index.vue"));
let default_1 = class extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.tableKey = 0;
    this.total = 0;
    this.list = [];
    this.listLoading = true;
    this.downloadLoading = false;
    this.listQuery = {
      enabled: true,
      page: 1,
      limit: 20,
      sort: 'id,DESC',
      adminId: _admin.AdminModule.id,
      filter: {
        id: '$ne',
        enabled: '$eq',
        adminId: '$eq'
      }
    };
    this.showCreatedDate = false;
    this.sortOptions = [{
      label: 'ID Ascending',
      key: 'id,ASC'
    }, {
      label: 'ID Descending',
      key: 'id,DESC'
    }];
    this.enableTypeOptions = [{
      key: true,
      value: 'Enable'
    }, {
      key: false,
      value: 'Disabled'
    }];
    this.filters = [];
  }
  created() {
    this.getList();
  }
  async getList() {
    try {
      this.listLoading = true;
      const data = await (0, _leadsNotifications.getLeadsNotifications)((0, _index2.getQuery)(this.listQuery));
      this.list = data.data;
      this.total = data.total;
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  async markNotificationRead(notification) {
    if (!notification.isRead) {
      (0, _leadsNotifications.markNotificationAsRead)(notification.id);
    }
    this.getList();
    const response = await (0, _leadsNotifications.getUnreadLeadsNotifications)({});
    _eventBus.EventBus.$emit('updated-notification', response);
    // redirect to respective page, notification.page & notification.params
    if (notification.page) {
      let page = '';
      if (notification.page === 'followup') {
        const params = JSON.parse(notification.params);
        page = 'Follow-up';
      }
      this.$router.push({
        name: page,
        params: JSON.parse(notification.params) || {}
      });
    }
  }
  handleFilter() {
    this.listQuery.page = 1;
    this.getList();
  }
  sortChange(data) {
    const {
      prop,
      order
    } = data;
    if (prop) {
      this.listQuery.sort = `${prop},` + (order === 'ascending' ? 'ASC' : 'DESC');
      this.handleFilter();
    }
  }
  getSortClass(key) {
    const sort = this.listQuery.sort;
    return sort === `${key},ASC` ? 'ascending' : sort === `${key},DESC` ? 'descending' : '';
  }
  handleDownload() {
    this.downloadLoading = true;
    const tHeader = ['ID', 'Full Name', 'Email', 'Contact Number', 'Status', 'timestamp'];
    const filterVal = ['id', 'fullName', 'email', 'contactNumber', 'enabled', 'createdTimestamp'];
    const data = (0, _index2.formatJson)(filterVal, this.list);
    (0, _excel.exportJson2Excel)(tHeader, data, this.$tc('route.notifications.title'));
    this.downloadLoading = false;
  }
};
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'NotificationsList',
  components: {
    Pagination: _index.default,
    Enabled: _index3.default
  }
})], default_1);
var _default = exports.default = default_1;